import { cloneDeep, isEqual } from 'es-toolkit';
import { untrack } from 'svelte';

export const asWorkData = <T>(data: () => T) => {
  let workData = $state(cloneDeep(data()));
  const dirty = $derived(!isEqual(workData, data()));

  function reset() {
    workData = cloneDeep(data());
  }

  $effect(() => {
    if (data()) untrack(() => reset());
  });

  return {
    get data() {
      return workData;
    },
    set data(value: T) {
      workData = value;
    },
    get dirty() {
      return dirty;
    },
    reset,
  };
};
